exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.box {\r\n  width: 280px;\r\n  margin-right: auto !important;\r\n  margin-left: auto !important;\r\n  padding-top: 30vh;\r\n  position: relative;\r\n  z-index: 1;\r\n  background-size:cover;\r\n}\r\n\r\ninput {\r\n  border-top: none;\r\n  border-left: none;\r\n  border-right: none;\r\n  box-shadow: none;\r\n  border-radius: 0px;\r\n}\r\n\r\ninput:focus {\r\n  border-right: none;\r\n  border-top: none;\r\n  border-left: none;\r\n  box-shadow: none;\r\n  border-radius: 0px;\r\n}\r\n\r\n.login {\r\n  margin: 0px;\r\n  padding: 0px;\r\n  height: 100vh;\r\n  background-size: cover; \r\n}\r\n\r\n.login-backdrop {\r\n  background-color: #d2d2d2;\r\n  opacity: 0.5;\r\n  width: 100%;\r\n  position: fixed;\r\n  height: 100vh;\r\n}\r\n\r\n.error-msg-bg {\r\n  background-color: aliceblue;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main